import { useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
import { AVATAR_URL } from './constants';

const BotAvatar = () => (
  <div className="w-8 h-8 rounded-full overflow-hidden border border-[#007AFF] flex-shrink-0">
    <img src={AVATAR_URL} alt="Assistant" className="w-full h-full object-cover" />
  </div>
);

const TypingIndicator = () => (
  <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="flex gap-3">
    <BotAvatar />
    <div className="bg-[#1a1a1a] border border-[#27272A] p-3 rounded-lg">
      <div className="flex gap-1">
        <span className="w-2 h-2 bg-[#52525B] rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
        <span className="w-2 h-2 bg-[#52525B] rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
        <span className="w-2 h-2 bg-[#52525B] rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  </motion.div>
);

export const ChatMessages = ({ messages, isLoading }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isLoading]);

  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4 min-h-[150px]">
      {messages.map((msg, index) => (
        <motion.div
          key={`msg-${index}-${msg.role}`}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className={`flex gap-3 ${msg.role === 'user' ? 'flex-row-reverse' : ''}`}
        >
          {msg.role === 'user' ? (
            <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 bg-[#27272A]">
              <User className="w-4 h-4 text-white" />
            </div>
          ) : (
            <BotAvatar />
          )}
          <div
            className={`max-w-[75%] p-3 rounded-lg ${
              msg.role === 'user'
                ? 'bg-[#007AFF] text-white'
                : 'bg-[#1a1a1a] text-[#e4e4e7] border border-[#27272A]'
            }`}
          >
            <p className="text-sm leading-relaxed whitespace-pre-wrap">{msg.content}</p>
          </div>
        </motion.div>
      ))}
      {isLoading && <TypingIndicator />}
      <div ref={messagesEndRef} />
    </div>
  );
};
